import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { IconButton, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import "./Product.css";

function ListadoCantidadProductos(props) {
  const {
    venta,
    eliminarProductoVenta,
    handleChangeQuantity,
    restarProductos,
    aumentarProductos,
    index,
  } = props;

  const price = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(venta.price);

  const totalProduct = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(venta.final_price);

  return (
    <TableRow className="product-row">
      {/* Product info: image + name + tag */}
      <TableCell>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {venta.image && (
            <img
              src={venta.image}
              alt={venta.name}
              className="product-avatar"
            />
          )}
          <div className="product-name-cell">
            <span className="name">{venta.name}</span>
            {venta.tag && <span className="tag">{venta.tag}</span>}
          </div>
        </div>
      </TableCell>

      {/* Quantity controls */}
      <TableCell align="center">
        <div className="qty-controls">
          <button onClick={() => restarProductos(index)}>
            <RemoveIcon style={{ fontSize: 14 }} />
          </button>
          <input
            type="text"
            value={venta.cantidad}
            onChange={(e) => handleChangeQuantity(e, index)}
          />
          <button onClick={() => aumentarProductos(index)}>
            <AddIcon style={{ fontSize: 14 }} />
          </button>
        </div>
      </TableCell>

      {/* Stock */}
      <TableCell align="center">
        <span className={`stock-badge ${venta.quantity <= 5 ? "low" : ""}`}>
          {venta.quantity} pzs
        </span>
      </TableCell>

      {/* Price */}
      <TableCell align="right" style={{ color: "#555", fontSize: "0.85rem" }}>
        {price}
      </TableCell>

      {/* Total */}
      <TableCell align="right">
        <b style={{ fontSize: "0.9rem", color: "#1a237e" }}>{totalProduct}</b>
      </TableCell>

      {/* Delete */}
      <TableCell align="center">
        <Tooltip title="Eliminar" arrow>
          <IconButton
            className="delete-btn"
            size="small"
            onClick={() => eliminarProductoVenta(venta.product_id)}
          >
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

export default ListadoCantidadProductos;
